// @flow
import NavBarContainer from './NavBarContainer';
export default NavBarContainer;
